import React, { FunctionComponent } from 'react';

import styles from './ReportsTweetsToDownload.module.scss';
import { Grid } from '@material-ui/core';
import { apiRoutes as hashtagsApiRoutes } from 'hashtags/utils/apiRoutes';
import TweetColumnToDownload from '../TweetColumnToDownload';
import { flatMap } from 'app/utils/array-flat-map';

interface Props {
  currentHashtag?: any;
  compId: string;
  showSlugs?: any;
  reportState?: any;
  filters?: any;
}

const ReportsTweetsToDownload: FunctionComponent<Props> = ({
  currentHashtag,
  compId,
  showSlugs,
  reportState,
  filters,
}) => {
  const currentSlugs = showSlugs;
  const getReq = (slug: string) =>
    slug?.includes('instagram')
      ? hashtagsApiRoutes().hashtagInstaPosts
      : slug?.includes('linkedin')
        ? hashtagsApiRoutes().hashtagLinkedInPosts
        : slug?.includes('youtube')
          ? hashtagsApiRoutes().hashtagVideos
          : slug?.includes('tiktok')
            ? hashtagsApiRoutes().hashtagTiktokPosts
            : hashtagsApiRoutes().hashtagTweets;

  const renderPage = () => {
    const tweetsColumn = currentSlugs?.map((item: any, index: number) => [
      {
        id: item?.slug,
        component: (
          <Grid item lg={4} md={12}>
            <TweetColumnToDownload
              requestUrl={getReq(item?.slug)}
              type={
                item?.slug?.includes('negative')
                  ? 'negative'
                  : item?.slug?.includes('positive')
                    ? 'positive'
                    : item?.slug?.includes('neutral')
                      ? 'neutral'
                      : 'all'
              }
              customFilters={{
                hashtag_id: +item?.item_id,
                limit: item?.item_count,
                order_column: item?.item_sort_type?.sort_colum,
                type_of_sort: item?.sort_type,
                ...filters,
              }}
              compId={`${item?.slug}_${index + 1}`}
              hideSort={true}
              isReport={true}
              hideQuestionmarkIcon={true}
              reportState={reportState}
              isTemplate={true}
            />
          </Grid>
        ),
      },
    ]);

    return flatMap(tweetsColumn)
      ?.filter((item) =>
        currentSlugs?.some((i: any) => i?.slug === item?.id)
          ? {
              ...item,
              order: currentSlugs.map((i: any) => i?.slug === item?.id)?.[0]
                ?.item_sort_type_id,
            }
          : false,
      )
      .sort((a, b) => a.order - b.order)

      .map((item) => item.component);
  };

  return (
    <div
      className={styles.ReportsTweetsToDownload}
      id={`${compId}-tweetsColumnTabs`}
    >
      <Grid container spacing={4} id={`${compId}-tweetsTabs-columns`}>
        {renderPage()}
      </Grid>
    </div>
  );
};

export default ReportsTweetsToDownload;
